import ProductCard from "@/app/components/elements/cards/productCard/ProductCard";
import { Product } from "@/app/lib/features/product/product.types";

interface ProductsGridProps {
  products: Product[];
  columns?: 2 | 3 | 4 | 5;
}

const columnClasses: Record<
  NonNullable<ProductsGridProps["columns"]>,
  string
> = {
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
};

const ProductsGrid = ({ products, columns = 5 }: ProductsGridProps) => {
  if (!products || products.length === 0) return null;

  return (
    <div className={`grid ${columnClasses[columns]} gap-3 sm:gap-4`}>
      {products.map((product, index) => (
        <ProductCard
          key={`${product.id}-${product.variant_id}`}
          product={product}
          priority={index < columns}
        />
      ))}
    </div>
  );
};

export default ProductsGrid;
